import { render, staticRenderFns } from "./CiModalDialog.vue?vue&type=template&id=e60c6012&scoped=true"
import script from "./CiModalDialog.vue?vue&type=script&lang=js"
export * from "./CiModalDialog.vue?vue&type=script&lang=js"
import style0 from "./CiModalDialog.vue?vue&type=style&index=0&id=e60c6012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c6012",
  null
  
)

export default component.exports